import { render } from "./PsLink.vue?vue&type=template&id=1fd77134&ts=true"
import script from "./PsLink.vue?vue&type=script&lang=ts"
export * from "./PsLink.vue?vue&type=script&lang=ts"

import exportComponent from "G:\\wamp\\www\\vahanwale\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__